import { put, select } from 'redux-saga/effects'

import { isWebsiteBookingsPageSelector } from 'reduxModules/selectors/RouterSelectors'
import { routeIdSelector, fromUaRouteSelector } from 'reduxModules/selectors/RouteSelectors'
import { isPartnerSelector, isLimitedDispatcherSelector } from 'reduxModules/selectors/UserSelectors'
import { routeActions } from 'reduxModules/actions/RouteActions'
import { bookingActions } from 'reduxModules/actions/BookingActions'

export function* selectDateSaga() {
  const routeId = yield select(routeIdSelector)
  const isPartner = yield select(isPartnerSelector)
  const isLimitedDispatcher = yield select(isLimitedDispatcherSelector)
  const isWebsiteBookingsPage = yield select(isWebsiteBookingsPageSelector)

  if (isWebsiteBookingsPage) {
    yield put(bookingActions.unsubscribeWebsiteBookings())
    yield put(bookingActions.subscribeWebsiteBookings())
  }
  
  if (routeId) {
    const splitedRouteId = routeId.split('_')
    const fromUaRoute = yield select(fromUaRouteSelector)
    
    yield put(routeActions.unsubscribeInfo())
    yield put(routeActions.unsubscribeWaitingPassengers())
    yield put(bookingActions.unsubscribeBookings())
    yield put(bookingActions.unsubscribeReturnBookings())

    yield put(bookingActions.subscribeBookings())
    yield put(routeActions.subscribeInfo())
    yield put(routeActions.subscribeWaitingPassengers())

    if ((!isPartner && !isLimitedDispatcher) && fromUaRoute) {
      const returnRouteId = splitedRouteId[1] + '_' + splitedRouteId[0]

      yield put(bookingActions.subscribeReturnBookings(returnRouteId))
    }
  }
}



// WEBPACK FOOTER //
// ./src/reduxModules/sagas/DateSagas.js